import { render, staticRenderFns } from "./TfnRegistration.vue?vue&type=template&id=3d480ae0&"
import script from "./TfnRegistration.vue?vue&type=script&lang=js&"
export * from "./TfnRegistration.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/sections/form-tfn.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports